import { z } from 'zod';

/** Sent through the client without key conversion, so it carries the API's key names. */
export const zodDeleteDeliveryNotesAdminPayloadSchema = z.object({
  asset_ids: z.array(z.uuid()).min(1),
});

/**
 * Counts of what the deletion removed: Postgres delivery note versions, Couchbase asset mains
 * and Redis cache keys. `deletedDbInfo` has one entry per requested ID, in request order.
 */
export const zodDeleteDeliveryNotesAdminResponseSchema = z.object({
  deletedCb: z.int().nonnegative(),
  deletedDb: z.int().nonnegative(),
  deletedDbInfo: z.array(z.object({ deliveryNote: z.int().nonnegative() })),
  deletedRh: z.int().nonnegative(),
});
